export default ({ tabs, tabKey, setTabKey }) => {
  const onSetTab = useCallback((e) => {
    setTabKey(e.target.dataset.key)
  })

  return (
    <div className="fcol flex-1">
      <div className="frow justify-evenly border-b-gray-900-60t mb-d">
        {tabs.map((tab) => {
          return (
            <div
              className={`${tabKey == tab.key ? 'text-blue-600' : 'text-gray-900'} text-sm pb-1`}
              onClick={onSetTab}
              data-key={tab.key}
              key={tab.key}
            >
              {tab.text}
            </div>
          )
        })}
      </div>
      {
        tabs.find((tab) => {
          return tab.key == tabKey
        }).element
      }
    </div>
  )
}
